import type { ProgressSpinnerDesignTokens, ProgressSpinnerTokenSections } from '@primeuix/themes/types/progressspinner';

export const colorScheme: ProgressSpinnerTokenSections.ColorScheme = {
    light: {
        root: {
            // brand colours only (was blue/red/green/yellow)
            colorOne: '{primary.color}',
            colorTwo: '{extend.textheading}',
            colorThree: '{primary.color}',
            colorFour: '{extend.textheading}'
        }
    },
    dark: {
        root: {
            colorOne: '{blue.400}',
            colorTwo: '{red.400}',
            colorThree: '{green.400}',
            colorFour: '{yellow.400}'
        }
    }
};

export default {
    colorScheme
} satisfies ProgressSpinnerDesignTokens;